import { render, staticRenderFns } from "./AddStoreInfo.vue?vue&type=template&id=464a5bc8"
import script from "./AddStoreInfo.vue?vue&type=script&lang=js"
export * from "./AddStoreInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports